var map = {
	"./_module_demo_/client/typePolicies.js": [
		44543,
		44543
	],
	"./assistant/client/typePolicies.js": [
		7231,
		7231
	],
	"./kitchen-order-ticket/client/typePolicies.js": [
		52194,
		52194
	],
	"./menu-management/client/typePolicies.js": [
		64874,
		67134
	],
	"./settings/client/typePolicies.js": [
		85930,
		85930
	],
	"./sport-hub/client/typePolicies.js": [
		61405,
		61405
	],
	"./waitress-order-ticket/client/typePolicies.js": [
		93851,
		93851
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 57059;
module.exports = webpackAsyncContext;